import { render, staticRenderFns } from "./LoadingAnim.vue?vue&type=template&id=54d9db59"
import script from "./LoadingAnim.vue?vue&type=script&lang=js"
export * from "./LoadingAnim.vue?vue&type=script&lang=js"
import style0 from "./LoadingAnim.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports